import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NavigationService } from '../../../services/navigation.service';
import { Router } from '@angular/router';
import { AccountService } from '../../../services/account.service';
import { DetailService } from '../../../services/detail.service';

@Component({
  selector: 'app-right-nav',
  templateUrl: './right-nav.component.html',
  providers: [DetailService]
})
export class RightNavComponent implements OnInit {
  expanded: boolean = false;
  entityName: string;
  entityId: string;
  model: any = null;

  showNotesAdd: boolean = false;

  isAdmin: boolean = false;
  userRole: number = 0;


  constructor(
    private navigationService: NavigationService,
    private ref: ChangeDetectorRef,
    private detailService: DetailService,
    private router: Router,
    private accountService: AccountService) {
  }

  ngOnInit() {
    this.userRole = +localStorage.getItem('userRole');
    this.isAdmin = !!localStorage.getItem('isAdmin');

    let nav = this.navigationService.getNav();

    if (nav != null) {
      this.expanded = nav.showRightNav;
    }

    if (nav.rightNav != null) {
      this.entityName = nav.rightNav.entityName;
      this.entityId = nav.rightNav.entityId;
    }



    this.navigationService.showRightNav$.subscribe(s => {
      this.expanded = s;
      this.ref.markForCheck();
    });

    this.navigationService.rightNav$.subscribe(s => {
      this.entityId = s.entityId;
      this.entityName = s.entityName;
      this.load();
      this.ref.markForCheck();
    });

    this.setPermissions();

    this.load();
    this.ref.markForCheck();
  }

  setPermissions() {
    if (this.userRole == 3 || this.isAdmin) {
      this.showNotesAdd = true;
    }
  }


  load() {
    switch (this.entityName) {
      case 'user':
        this.detailService.user(this.entityId)
          .subscribe(r => {
            this.model = r.body.result;
            this.ref.markForCheck();
          });
        break;
      case 'order':
        this.detailService.order(this.entityId)
          .subscribe(r => {
            this.model = r.body.result;
            this.ref.markForCheck();
          });
        break;
      case 'invoice':
        this.detailService.invoice(this.entityId, true)
          .subscribe(r => {
            this.model = r.body.result;
            this.ref.markForCheck();
          });
        break;
      case 'location':
        this.detailService.location(this.entityId)
          .subscribe(r => {
            this.model = r.body.result;
            this.ref.markForCheck();
          });
        break;
      case 'quote':
        this.detailService.quote(this.entityId)
          .subscribe(r => {
            this.model = r.body.result;
            this.ref.markForCheck();
          });
        break;
    }
  }

  clickTab(tab: string) {
    this.navigationService.setLeftNav(tab);
  }

  clickArea(area: string) {
    this.navigationService.setLeftNav(null, area);

    switch (area) {
      case 'orders':
        this.router.navigateByUrl('/orders');
        break;
      case 'invoices':
        this.router.navigateByUrl('/invoices');
        break;
      case 'locations':
        this.router.navigateByUrl('/locations');
        break;
      case 'users':
        this.router.navigateByUrl('/users');
        break;
      case 'quotes':
        this.router.navigateByUrl('/quotes');
        break;
    }
  }

  clickChild(child: string) {
    this.navigationService.setLeftNav(null, null, child);
  }

  logout() {
    this.accountService.logout();
  }

  close() {
    this.navigationService.showRightNav(false);
  }
}
